import React from "react";
import style from "./OutcomeBlock.module.scss";
import { SelectBox } from "../../../../../primary";
import { BLEEDING_AMOUNT, PAIN_SCALE, YES_NO } from "../debridementConfig";

/**
 * Block 3 — Outcome. Captured after the procedure.
 *
 * Two V1 nodes are split across blocks because each holds two moments:
 *   • pain — "right before" lives in Block 1, "right after" lives here
 *   • bleeding — amount here, and "pressure required" conditional on it
 */
export const OutcomeBlock = ({ form, showPressure, disabled, onField }) => (
  <section className={`${style.block} ${disabled ? style.block_off : ""}`}>
    <div className={style.block_head_static}>
      <span className={style.block_num}>3</span>
      <span className={style.block_title}>Outcome</span>
    </div>

    <div className={style.block_body}>
      <div className={style.row2} style={{ gridTemplateColumns: "1fr"}}>
        <div className={style.field}>
          <label htmlFor="painAfter">Pain scale right after procedure</label>
          <SelectBox
            id="painAfter"
            name="painAfter"
            optionValue={PAIN_SCALE}
            defaultValue={form.painAfter === null ? "" : String(form.painAfter)}
            placeholder="0–10…"
            disabled={disabled}
            classes={{ inputClassName: style.custom_basic_select }}
            onChange={(e) => onField("painAfter", e.target.value)}
          />
          <p className={style.hint}>Same 0–10 scale as the “before” capture in Block 1.</p>
        </div>

        <div className={style.field}>
          <label htmlFor="postDebridementBleedingAmount">Bleeding</label>
          <SelectBox
            id="postDebridementBleedingAmount"
            name="postDebridementBleedingAmount"
            optionValue={BLEEDING_AMOUNT}
            defaultValue={form.postDebridementBleedingAmount || ""}
            placeholder="Select…"
            disabled={disabled}
            classes={{ inputClassName: style.custom_basic_select }}
            onChange={(e) => onField("postDebridementBleedingAmount", e.target.value)}
          />
        </div>
      </div>

      {showPressure && (
        <div className={style.field} data-testid="pressure-field">
          <label htmlFor="stoppedBleedingContactPressure">
            Pressure required to stop bleeding?
          </label>
          <SelectBox
            id="stoppedBleedingContactPressure"
            name="stoppedBleedingContactPressure"
            optionValue={YES_NO}
            defaultValue={form.stoppedBleedingContactPressure || ""}
            placeholder="Select…"
            disabled={disabled}
            classes={{ inputClassName: style.custom_basic_select }}
            onChange={(e) => onField("stoppedBleedingContactPressure", e.target.value)}
          />
        </div>
      )}
    </div>
  </section>
);
